document.addEventListener('DOMContentLoaded', function() {
  const appWrapper = document.querySelector('[data-app-wrapper]');
  if (!appWrapper) return;

  let observerActive = true;

  function checkAppContent() {
    const okeReviews = appWrapper.querySelector('.okeReviews');
    
    if (!okeReviews) {
      // Si no hay Okendo, ocultar la sección y detener el observer
      appWrapper.classList.add('app-wrapper--no-content');
      console.log('Ocultando sección - no Okendo encontrado');
      
      // Detener el observer para evitar loops
      if (observerActive) {
        observer.disconnect();
        observerActive = false;
        console.log('Observer detenido - no hay Okendo');
      }
      return;
    }

    // Verificar si hay datos de reviews en el JSON
    let reviewCount = 0;
    const metafieldData = okeReviews.querySelector('[data-oke-metafield-data]');
    
    if (metafieldData) {
      try {
        const data = JSON.parse(metafieldData.textContent || '{}');
        reviewCount = data.reviewAggregate?.ratingAndReviewCount || data.reviews?.length || 0;
      } catch (e) {
        console.log('Error parsing Okendo data:', e);
      }
    }
    
    // Verificar elementos visibles de reviews
    const hasReviewElements = okeReviews.querySelector('.oke-w-review');
    const hasReviewsList = okeReviews.querySelector('.oke-w-reviews-list');
    
    console.log('Estado Okendo:', {
      reviewCount,
      hasReviewElements,
      hasReviewsList,
      hasMetafieldData: !!metafieldData
    });

    // Lógica estricta: solo mostrar si hay reviews reales
    const hasRealReviews = reviewCount > 0 || hasReviewElements || hasReviewsList;

    if (!hasRealReviews) {
      appWrapper.classList.add('app-wrapper--no-content');
      console.log('Ocultando sección - sin reviews reales');
      
      // Detener el observer para evitar loops cuando no hay contenido
      if (observerActive) {
        observer.disconnect();
        observerActive = false;
        console.log('Observer detenido - sin reviews reales');
      }
    } else {
      appWrapper.classList.remove('app-wrapper--no-content');
      console.log('Mostrando sección - con reviews reales');
      
      // Reactivar observer si estaba detenido y ahora hay contenido
      if (!observerActive) {
        observer.observe(appWrapper, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-oke-reviews-count', 'class', 'data-oke-metafield-data']
        });
        observerActive = true;
        console.log('Observer reactivado - hay reviews');
      }
    }
  }

  // Verificar inicialmente y dejar que el observer maneje el resto
  setTimeout(checkAppContent, 800);

  // Observer más eficiente y específico
  const observer = new MutationObserver(function(mutations) {
    let shouldCheck = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        // Solo si hay cambios directos en el appWrapper o se añaden elementos oke
        if (mutation.target === appWrapper || 
            Array.from(mutation.addedNodes).some(node => 
              node.nodeType === 1 && (
                node.classList?.contains('okeReviews') ||
                node.querySelector?.('.okeReviews') ||
                node.querySelector?.('[data-oke-metafield-data]')
              )
            )) {
          shouldCheck = true;
        }
      } else if (mutation.type === 'attributes') {
        // Solo cambios en atributos oke específicos
        if (mutation.attributeName?.startsWith('data-oke') || 
            (mutation.target.classList?.contains('okeReviews') && 
             mutation.attributeName === 'class')) {
          shouldCheck = true;
        }
      }
    });
    
    if (shouldCheck) {
      // Prevenir múltiples llamadas rápidas
      setTimeout(checkAppContent, 200);
    }
  });

  // Observar solo el appWrapper y sus alrededores, no todo el body
  observer.observe(appWrapper, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-oke-reviews-count', 'class', 'data-oke-metafield-data']
  });
});
